import { useBackend } from "../../services";
import { EquipmentStatus } from "../equipments";

export const useAddGearItem = () => {
  const { post } = useBackend();
  const addGearItem = (parameters: IAddGearItemParameters) => post("gearItems", parameters);
  return { addGearItem };
};

export interface IAddGearItemParameters {
  name: string;
  brand?: string;
  description?: string;
  status: EquipmentStatus;
}
